import React, { useState } from 'react'

import { ReactComponent as NotifcationIcon } from 'assets/icons/bell.svg'
import Select from 'util/modules/Form/Select'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ApplicationState } from 'AppReducer'
import { getPartnerList } from 'panel/partner/redux/actions'
import { createNotification } from '../redux/actions'
import { getProductList } from 'panel/product/redux/actions'

const initialState = { title: '', message: '', action: 'open-product', payload: { partner: 0, product: 0 } }
const NotificationForm: React.FC = () => {
  const dispatch = useDispatch()
  const [form, setForm] = useState(initialState)

  const { partnerList: { items: partners } } = useSelector((state: ApplicationState) => state.partnerReducer)
  const { products: { items: products } } = useSelector((state: ApplicationState) => state.partnerProductReducer)

  function handleSubmit (e: React.FormEvent): void {
    e.preventDefault()
    createNotification(form)(dispatch).then(res => {
      if (res?.status === 'success') {
        handleClear()
      }
    })
  }

  function handleClear (): void {
    setForm(initialState)
  }

  function handleFetchProduct (partnerId: number): void {
    getProductList(partnerId, {
      fields: 'id,name',
      'filter[isActive]': 1,
      'filter[product.isSellable]': 1,
      'sort[product.name]': 'ASC'
    })(dispatch)
  }

  useEffect(() => {
    getPartnerList({ fields: 'id,name', 'sort[name]': 'ASC' })(dispatch)
  }, [dispatch])

  return (
    <form className="row panel" onSubmit={handleSubmit}>
      <div className="row justify-start">
        <h2><NotifcationIcon width="35" height="30" /> Enviar Notificação</h2>

        <div className="row">
          <div className="form-control">
            <label>Título</label>
            <input
              type="text"
              value={form.title}
              onChange={(e): void => setForm({ ...form, title: e.target.value })}
              required
            />
          </div>

          <div className="form-control">
            <label>Mensagem</label>
            <input
              type="text"
              value={form.message}
              onChange={(e): void => setForm({ ...form, message: e.target.value })}
              required
            />
          </div>
        </div>

        <div className="row">
          <div className={`form-control ${form.action ? 'col-4' : 'col-12'}`}>
            <label>Ação</label>
            <select
              value={form.action}
              onChange={(e): void => setForm({
                ...form,
                action: e.target.value,
                payload: initialState['payload']
              })}
            >
              <option></option>
              <option value="open-partner">Abrir Parceiro</option>
              <option value="open-product">Abrir Produto</option>
            </select>
          </div>

          {
            !!form.action &&
            <div className={`form-control ${form.action === 'open-product' ? 'col-4' : 'col-8'}`}>
              <label>Parceiro</label>
              <Select
                itens={partners.map(({ id, name }) => ({ key: id, value: name }))}
                onSelect={(id): void => {
                  setForm({ ...form, payload: { ...form.payload, partner: id } })
                  if (form.action === 'open-product') {
                    handleFetchProduct(id)
                  }
                }}
                selected={form.payload.partner}
                required={true}
              />
            </div>
          }

          {
            form.action === 'open-product' &&
            <div className="form-control col-4">
              <label>Produto</label>
              <Select
                itens={products.map(({ id, product: { name } }) => ({ key: id, value: name }))}
                onSelect={(id): void => setForm({ ...form, payload: { ...form.payload, product: id } })}
                selected={form.payload.product}
                required={true}
              />
            </div>
          }
        </div>

        <div className="row justify-end margin-top-16">
          <span className="button secondary margin-right-8" style={{ width: 250 }} onClick={handleClear}>
            Limpar
          </span>
          <button className="primary" style={{ width: 250 }}>
            Enviar Notificação
          </button>
        </div>
      </div>
    </form>
  )
}

export default NotificationForm
